"use client";

import { Shield } from "lucide-react";
import { LoginForm } from "./LoginForm";

/** Full-bleed centered sign-in card — used as both the logged-out landing
 * page ("/") and the standalone /login page, so the two stay visually and
 * behaviorally identical. Rendered with no sidebar (Rail hides itself while
 * logged out) so it gets the full width to center in. */
export function SignInCard() {
  return (
    <div className="relative flex min-h-screen items-center justify-center px-6 py-12">
      <div
        className="pointer-events-none absolute inset-0 opacity-70"
        style={{
          backgroundImage:
            "radial-gradient(600px 320px at 15% 15%, #0b5fa514, transparent 60%), radial-gradient(560px 320px at 85% 85%, #0e8f5f14, transparent 60%)",
        }}
      />
      <div className="dash-in relative w-full max-w-sm overflow-hidden rounded-md border border-[var(--line)] bg-white shadow-[0_16px_40px_-12px_rgba(15,40,60,0.22)]">
        <div
          className="h-1.5 w-full"
          style={{ backgroundImage: "linear-gradient(100deg, var(--blue) 0%, var(--blue-2) 45%, var(--green-2) 100%)" }}
        />
        <div className="flex flex-col items-center gap-2 px-8 pb-1 pt-9 text-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#0b5fa512] text-[var(--blue)]">
            <Shield size={26} />
          </div>
          <h1 className="font-display text-[19px] font-semibold tracking-tight">Sign in to UAS Registry</h1>
          <p className="text-[12.5px] leading-relaxed text-[var(--muted)]">
            Applicants, committee members and reviewers all sign in here.
          </p>
        </div>
        <div className="px-8 pb-9 pt-6">
          <LoginForm />
        </div>
      </div>
    </div>
  );
}
